import GoodsOption from '@/models/cart/GoodsOption';

export default class SettlementHistory {
  constructor() {
    this.historyDate = '';
    this.entryCode = '';
    this.totalAmount = 0;
    this.rankCode = '';
    this.title = '';
    this.resultCode = '';
    this.thumbnail = '';
    this.alternativeText = '';
    this.status = '';
    this.isGoods = false;
    this.quantity = 1;
    this.goodsOptions = new Array<GoodsOption>();
  }

  public historyDate: string;

  public entryCode: string;

  public totalAmount: number;

  public rankCode: string;

  public title: string;

  public resultCode: string;

  public thumbnail: string;

  public alternativeText: string;

  public status: string;

  public isGoods: boolean;

  public quantity: number;

  public goodsOptions: GoodsOption[];

  public get buttonText(): string {
    if (this.isGoods) {
      return 'グッズ詳細';
    }
    if (this.resultCode) {
      return '結果&特典へ';
    }
    return '参加する';
  }
}
